import React from 'react';

export interface IconProps {
  code: string,
}

export const Icon = (props: IconProps) => {
  return <i className={'icon ' + props.code}/>;
};
